import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { isEmpty } from "lodash";
import moment from "moment";

import { Button, Stack, Typography } from "@mui/material";
import {
  IconCalendar,
  IconClock,
  IconEdit,
  IconEye,
} from "@tabler/icons-react";

import ClassesDetails from "./ClassesDetails";
import { Empty } from "./Empty";

const ClassesCalendar = ({
  data,
  dateCalendar,
  refetch,
}: {
  data: {
    classes: { id: string; date: Date }[];
    sessions: { id: string; date: Date }[];
  };
  dateCalendar: Date;
  refetch: () => void;
}) => {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [selectedValue, setSelectedValue] = useState<{
    id: string;
    date?: Date;
    startTime?: Date;
    endTime?: Date;
    name: string;
    description?: string;
    fightsId: string;
    spacesId: string;
    professorId?: Array<string>;
    automaticCompletion: boolean;
  }>({
    id: "",
    name: "",
    description: "",
    fightsId: "",
    spacesId: "",
    automaticCompletion: false,
  });
  const dates = data?.classes?.map((i) => i.date);
  const uniqueSortedDates = [...new Set(dates)]
    .map((date) => moment(date))
    .sort((a: any, b: any) => a - b)
    .map((date) => date.toISOString());

  const handleOpen = (v: any) => {
    setSelectedValue(v);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedValue({
      id: "",
      name: "",
      description: "",
      fightsId: "",
      spacesId: "",
      automaticCompletion: false,
    });
  };

  const filterdData = uniqueSortedDates?.filter(
    (date) =>
      moment(date).format("YYYY-MM-DD") ===
      moment(dateCalendar).format("YYYY-MM-DD")
  );

  return (
    <Stack
      direction="row"
      spacing={2}
      sx={{
        overflowX: "auto",
        width: "100%",
      }}
    >
      {!isEmpty(filterdData) ? (
        filterdData?.map((date, index) => (
          <Stack
            key={index}
            sx={{
              backgroundColor: "secondary.main",
              borderRadius: 2,
              width: "100%",
            }}
          >
            <Stack
              sx={{
                backgroundColor: "secondary.dark",
                flexDirection: "row",
                alignItems: "center",
                borderRadius: 2,
                padding: 1,
                gap: 1,
                mb: 2,
              }}
            >
              <IconCalendar color="#7600ED" />
              <Typography fontSize={12}>
                {moment(date).format("DD/MM/YYYY").toString()}
              </Typography>
            </Stack>
            <Stack spacing={3} sx={{ padding: 2 }}>
              {data.classes
                .filter((item: any) => item.date === date)
                .map((i: any) => {
                  return (
                    <Stack
                      key={i.id}
                      spacing={2}
                      sx={{
                        backgroundColor: "secondary.dark",
                        padding: 2,
                        borderRadius: 2,
                      }}
                    >
                      <Stack
                        flexDirection={"row"}
                        justifyContent={"space-between"}
                      >
                        <Stack>
                          <Typography variant="subtitle1" fontWeight={700}>
                            {i.name}
                          </Typography>

                          <Typography color="textSecondary">
                            {i?.fights?.name && (
                              <Typography component={"span"}>
                                {i?.fights?.name}
                              </Typography>
                            )}{" "}
                            {i?.fights?.name && (
                              <Typography component={"span"}>
                                {" - "}
                              </Typography>
                            )}
                            {i?.spaces?.name && (
                              <Typography component={"span"}>
                                {i?.spaces?.name}
                              </Typography>
                            )}
                          </Typography>
                        </Stack>
                        <Stack
                          justifyContent={"flex-end"}
                          alignItems={"flex-end"}
                        >
                          <Stack
                            sx={{
                              flexDirection: "row",
                              alignItems: "center",
                              gap: 1,
                            }}
                          >
                            <IconClock size={16} />
                            <Typography variant="body2" fontWeight={700}>
                              {moment(i.date).format("DD/MM/YYYY")}
                            </Typography>
                          </Stack>
                          <Typography variant="body2" fontWeight={700}>
                            {moment(i.startTime).format("HH:mm") +
                              "-" +
                              moment(i.endTime).format("HH:mm")}
                          </Typography>
                        </Stack>
                      </Stack>
                      <Stack spacing={1}>
                        <Button
                          variant="contained"
                          sx={{
                            justifyContent: "space-between",
                            fontWeight: 400,
                          }}
                          size="small"
                          endIcon={<IconEdit size={18} />}
                          onClick={() => handleOpen(i)}
                        >
                          Editar aula
                        </Button>
                        <Button
                          variant="contained"
                          size="small"
                          sx={{
                            justifyContent: "space-between",
                            fontWeight: 400,
                          }}
                          onClick={() => navigate(`/attendance-list/${i.id}`)}
                          endIcon={<IconEye size={18} />}
                        >
                          Detalhes da aula
                        </Button>
                      </Stack>
                    </Stack>
                  );
                })}
            </Stack>
          </Stack>
        ))
      ) : (
        <>
          <Stack
            sx={{
              backgroundColor: "secondary.main",
              borderRadius: 2,
              width: "100%",
            }}
          >
            <Stack
              sx={{
                backgroundColor: "secondary.dark",
                flexDirection: "row",
                alignItems: "center",
                borderRadius: 2,
                padding: 1,
                gap: 1,
                mb: 2,
              }}
            >
              <IconCalendar color="#7600ED" />
              <Typography fontSize={12}>
                {moment(dateCalendar).format("DD/MM/YYYY").toString()}
              </Typography>
            </Stack>
            <Stack spacing={3} sx={{ padding: 2 }}>
              <Empty data={[]} />
            </Stack>
          </Stack>
        </>
      )}
      <ClassesDetails
        open={open}
        onClose={handleClose}
        data={selectedValue}
        refetch={() => refetch()}
      />
    </Stack>
  );
};

export default ClassesCalendar;
